import React, { useState, useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './PropertyManagement.css';

const SampleCompetitorReport: React.FC = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const toggleFullscreen = useCallback(() => {
    setIsFullscreen((prev) => !prev);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setIsFullscreen(false);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <div className={`re-page ${isFullscreen ? 're-page--fullscreen' : ''}`}>
      <div className="re-bg">
        <div className="re-nebula re-nebula-1" />
        <div className="re-nebula re-nebula-2" />
        <div className="re-nebula re-nebula-3" />
      </div>

      <div className="re-content re-content--wide visible">
        <nav className="re-nav">
          <Link to="/property-management" className="re-back">
            ← Back to Property Management
          </Link>
          <button
            type="button"
            className="re-fullscreen-btn"
            onClick={toggleFullscreen}
            title={isFullscreen ? 'Exit full screen' : 'Full screen'}
            aria-label={isFullscreen ? 'Exit full screen' : 'Full screen'}
          >
            {isFullscreen ? '✕ Exit full screen' : '⛶ Full screen'}
          </button>
        </nav>

        <section className="re-report-section">
          <iframe
            className="re-report-iframe"
            src="/reports/MercedesHouse_CompetitorReport.html"
            title="Mercedes House Competitor Report — Biweekly"
          />
        </section>
      </div>

      {isFullscreen && (
        <button
          type="button"
          className="re-fullscreen-exit"
          onClick={toggleFullscreen}
          title="Exit full screen (Esc)"
          aria-label="Exit full screen"
        >
          ✕ Exit full screen
        </button>
      )}
    </div>
  );
};

export default SampleCompetitorReport;
